import type { FC } from 'react';

import { DodoLogo } from '../DodoLogo';

export const AnimeMascot: FC = () => (
	<div className='anime-mascot' aria-hidden='true'>
		<div className='anime-mascot-inner'>
			<div style={{ position: 'relative' }}>
				<DodoLogo size={80} />
				<div className='anime-eyes'>
					<div className='anime-eye anime-eye-left' />
					<div className='anime-eye anime-eye-right' />
					<div className='anime-blush anime-blush-left' />
					<div className='anime-blush anime-blush-right' />
				</div>
			</div>
		</div>
	</div>
);
